module.exports = __webpack_public_path__ + "static/media/appLab_rhyme_tester.e34577c3.png";